import React from 'react';

import ButtonIconText from '../../../resuable-ui/btn-icon-text';

import RetrieveIcon from '../../../svgs/RetrieveSvgIcon';
import ParkIcon from '../../../svgs/ParkIconSvg';
import DiscardIcon from '../../../svgs/DeleteIconSvg';

import Modal from '../../../resuable-ui/modal';

import { RetrieveModalContent } from '../record-modals/retrieve';
import { ParkSaleModal } from '../../../resuable-ui/modals-mobile/park-sale-modal';
import { DiscardSaleModal } from '../../../resuable-ui/modals-mobile/discard-sale-modal';
import { useGetCart, useGetParkedCart } from '../../../../integrations/react_query/queries';
import { ECart, EQuerykeys } from '../../../../models';
import styles from './index.module.scss';

enum Etypes {
	park = 'park',
	retrieve = 'retrieve',
	discard = 'discard',
}

type SalesNavProps = {
	onRetrieve?: () => void;
	onPark?: () => void;
	onDiscard?: () => void;
};

const SalesNav = ({ onRetrieve, onPark, onDiscard }: SalesNavProps = {}) => {
	const [show, setShow] = React.useState(false);

	const [type, setType] = React.useState<string | null>(null);

	const handleType = (type: string) => {
		setType(type);
		setShow(true);
	};

	const { data: cartItems } = useGetCart([EQuerykeys.cart, ECart.active]);

	const { data: parkedCartData } = useGetParkedCart([EQuerykeys.cart, ECart.parked]);

	const disableDiscardAndParkButtons = (cartItems?.products ?? [])?.length <= 0;

	const disableRetriveSalesButton = (parkedCartData ?? [])?.length <= 0;

	const handleRetrieve = onRetrieve ? onRetrieve : () => handleType(Etypes.retrieve);
	const handlePark = onPark ? onPark : () => handleType(Etypes.park);
	const handleDiscard = onDiscard ? onDiscard : () => handleType(Etypes.discard);

	return (
		<>
			<ParkSaleModal show={type === Etypes.park && show && !onPark} onClose={() => setShow(false)} />
			<DiscardSaleModal show={type === Etypes.discard && show && !onDiscard} onClose={() => setShow(false)} />
			
			{!onRetrieve && !onPark && !onDiscard && (
				<Modal
					{...{
						show: type === Etypes.retrieve && show,
						setShow,
						columnLayout: 'col-9 col-lg-8 col-xl-7 col-xxl-6',
					}}
				>
					{type === Etypes.retrieve && <RetrieveModalContent {...{ setShow }} />}
				</Modal>
			)}
			<section className={`d-flex align-items-center justify-content-between ${styles.wrapper}`}>
				<ButtonIconText type="button" disabled={disableRetriveSalesButton} onClick={handleRetrieve}>
					<RetrieveIcon id={Etypes.retrieve} />
					<span className="mx-1">Retrieve Sale</span>
				</ButtonIconText>

				<ButtonIconText type="button" disabled={disableDiscardAndParkButtons} onClick={handlePark}>
					<ParkIcon id={Etypes.park} />
					<span className="mx-1" id={Etypes.park}>
						Park Sale
					</span>
				</ButtonIconText>

				<ButtonIconText type="button" disabled={disableDiscardAndParkButtons} onClick={handleDiscard}>
					<DiscardIcon />
					<span className="mx-1">Discard Sale</span>
				</ButtonIconText>
			</section>
		</>
	);
};

export default SalesNav;

